import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

const SearchInput = ({
  className,
  name,
  placeholder,
  value,
  onChange,
  onSubmit,
}) => {
  return (
    <>
      <div className="input-group">
        <input
          type="text"
          name={name}
          className={className}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onKeyPress={e => {
            if (e.key === "Enter") {
              onSubmit();
            }
          }}
          // onBlur={() => {
          //   if (valueState !== value) {
          //     onChange(valueState);
          //   }
          // }}
        />
        <div className="input-group-append">
          <button
            className="btn btn-outline-search"
            type="button"
            onClick={() => {
              onSubmit();
            }}
          >
            <FontAwesomeIcon
              icon={faSearch}
              className="text-muted turn-icon"
              fixedWidth
              size="sm"
            />
          </button>
        </div>
      </div>
    </>
  );
};

export default SearchInput;
